// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"App_pageWrapper__46M7d"};